<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          ¡Muchas gracias por confiar en Faro Capital!
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
            Nos estaremos comunicando con usted a la brevedad posible para finalizar su proceso de suscripción.
          </p>
        </md-card-content> 
      </md-card>   

      <Botonera v-show="showin" :form="form" :back="back" :Bottontitle="'Enviar'"/>                  
    </div>
  </form>
</template>

<style>

</style>

<script>
import eventBus from '../bus'
export default {
  name: 'Form10',
  props:{complete: Number},
  data: () => ({
    showin:false
  }),
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      //this.$router.go(-1);
    }, 
    validateUser () {
      var that = this
      eventBus.$emit('isLoading', true);
      eventBus.$emit('buttonDisabled', true);
      this.$store.dispatch("saveFormulario", {form: null, ide: this.$route.params.id.toString(), complete: 1})
      .then((response)=>{
        eventBus.$emit('isLoading', false);
        that.showin = response.success
      })
      .catch(()=>{
          eventBus.$emit('isLoading', false);
      });
      
    },    
  },
  mounted: function(){
      //this.$store.dispatch("back", false);
      eventBus.$emit('isLoading', true);
      var that = this
        this.$store.dispatch("loadFormulario", this.$route.params.id.toString())
        .then((response)=>{
            that.showin = (response.complete == 0)?true: false;
            eventBus.$emit('isLoading', false);
        })
        .catch(()=>{
            eventBus.$emit('isLoading', false);
        });      
  }, 
  computed:{

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
